
import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Signin from "./pages/Signin";
import PublicStore from "./pages/PublicStore";

import ResellerDashboard from "./pages/reseller/ResellerDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ShopOwnerDashboard from "./pages/shopOwner/ShopOwnerDashboard";

// Public pages: Navbar and Footer are visible.
function PublicLayout() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}

// Dashboard pages: hide the public Navbar and Footer.
function DashboardLayout() {
  return (
    <main className="min-h-screen">
      <Outlet />
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public website */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signin" element={<Signin />} />
        </Route>

        {/* Public reseller storefront */}
        <Route
          path="/s/:slug"
          element={<PublicStore />}
        />

        {/* Reseller dashboard */}
        <Route
          element={
            <ProtectedRoute allowedRoles={["reseller"]} />
          }
        >
          <Route element={<DashboardLayout />}>
            <Route
              path="/reseller/dashboard"
              element={<ResellerDashboard />}
            />
          </Route>
        </Route>

        {/* Shop Owner dashboard */}
        <Route
          element={
            <ProtectedRoute allowedRoles={["shop-owner"]} />
          }
        >
          <Route element={<DashboardLayout />}>
            <Route
              path="/shop-owner/dashboard"
              element={<ShopOwnerDashboard />}
            />
          </Route>
        </Route>

        {/* Admin dashboard */}
        <Route
          element={
            <ProtectedRoute allowedRoles={["admin"]} />
          }
        >
          <Route element={<DashboardLayout />}>
            <Route
              path="/admin/dashboard"
              element={<AdminDashboard />}
            />
          </Route>
        </Route>

        {/* Unknown route */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}
